import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'LOJA_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}
export function initForm(registro = {}) {
    return [
        initialize('lojaForm', registro)
    ];
}

export function getLista() {
    const request = axios.get(`${consts.API_URL}/loja`);
    return {
        type: 'LOJA_LISTADO',
        payload: request
    };
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/loja`, {
				...registro,
				cnpj: FormatUtils.removerMascara(registro.cnpj),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/loja`, {
				...registro,
				cnpj: FormatUtils.removerMascara(registro.cnpj),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/loja?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaRegiao() {
    const request = axios.get(`${consts.API_URL}/regiao/listarSelect`);
    return {
        type: 'LOJA_REGIAO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaLocalEstoque() {
    const request = axios.get(`${consts.API_URL}/localEstoque/listarSelect`);
    return {
        type: 'LOJA_LOCAL_ESTOQUE_SELECT_LISTADO',
        payload: request
    };
}
